<script>
import PixelBase from "@/components/tools/PixelBase.vue";
export default {
  extends: PixelBase,
  data() {
    return {
      title: "Google Analytics",
      pixelType: "google_analytics"
    };
  }
};
</script>
